import {
  VarnishContext
} from "./chunk-BDRB3LP3.js";

// src/components/header/useSmartAI2Banner.ts
import React from "react";
import { useScrollTrigger } from "@mui/material";
var useSmartAI2Banner = ({
  containerRef,
  appBarRef,
  bannerRef,
  bannerAlwaysVisible = false
}) => {
  const ctx = React.useContext(VarnishContext);
  const appBarHeight = appBarRef.current == null ? 0 : appBarRef.current.getBoundingClientRect().height;
  const bannerHeight = bannerRef.current == null ? 0 : bannerRef.current.getBoundingClientRect().height;
  const paddingBottom = bannerRef.current == null ? 0 : parseFloat(window.getComputedStyle(bannerRef.current).paddingBottom || "0");
  const offset = -1 * (bannerHeight - paddingBottom);
  const shouldHideBanner = useScrollTrigger({ target: containerRef?.current ?? void 0 });
  const topOffset = shouldHideBanner ? offset : 0;
  const totalOffset = bannerAlwaysVisible ? 0 : topOffset;
  const headerHeight = appBarHeight + totalOffset;
  React.useEffect(() => {
    ctx.setHeaderHeight(headerHeight);
  }, [ctx, headerHeight]);
  return totalOffset;
};
var useSmartAI2Banner_default = useSmartAI2Banner;

export {
  useSmartAI2Banner,
  useSmartAI2Banner_default
};
//# sourceMappingURL=chunk-OKWD3XCP.js.map